import { AxiosError } from 'axios'
import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'
import type { AnyRouter } from '@tanstack/react-router'
import { toast } from 'sonner'
import { useAuthStore } from '@/stores/auth-store'

export function createQueryClient(getRouter: () => AnyRouter) {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnWindowFocus: false,
        staleTime: 5 * 60 * 1000, // 5 minutes
      },
    },
    mutationCache: new MutationCache({
      onError: (error, _variables, _context) => {
        if (error instanceof AxiosError) {
          const router = getRouter()
          if (error.response?.status === 401) {
            useAuthStore.getState().logout()
            const redirect = `${router.history.location.href}`
            router.navigate({ to: '/sign-in', search: { redirect } })
          } else if (error.response?.status === 500) {
            toast.error('خطایی سمت سرور رخ داده است')
            // Only navigate to error page in production to avoid disrupting HMR in development
            // if (import.meta.env.PROD) {
            //   router.navigate({ to: '/500' })
            // }
          } else if (error.response?.status === 403) {
            toast.error('دسترسی این عملیات را ندارید')
            // router.navigate("/forbidden", { replace: true });
          } else {
            toast.error(error?.response?.data?.message || 'خطایی رخ داده است')
          }
        }
      },
      onSuccess: (data, _variables, _context, mutation) => {
        if (mutation.meta?.showToastOnSuccess) {
          // Show custom message or default
          const message =
            typeof mutation.meta.successMessage === 'string'
              ? mutation.meta.successMessage
              : typeof data === 'object' && data !== null && 'message' in data
                ? (data?.message as string)
                : 'عملیات با موفقیت انجام شد'
          toast.success(message)
        }
      },
    }),
    queryCache: new QueryCache({
      onError: (error) => {
        if (error instanceof AxiosError) {
          const router = getRouter()
          if (error.response?.status === 401) {
            useAuthStore.getState().logout()
            const redirect = `${router.history.location.href}`
            router.navigate({ to: '/sign-in', search: { redirect } })
          } else if (error.response?.status === 500) {
            toast.error('خطایی سمت سرور رخ داده است')
            // Only navigate to error page in production to avoid disrupting HMR in development
            // if (import.meta.env.PROD) {
            //   router.navigate({ to: '/500' })
            // }
          } else if (error.response?.status === 403) {
            toast.error('دسترسی این عملیات را ندارید')
            // router.navigate("/forbidden", { replace: true });
          } else {
            toast.error(error?.response?.data?.message || 'خطایی رخ داده است')
          }
        }
      },
    }),
  })
}
